export const OFFLINE_MODE = false;
export const APP_CLASS = 48;
export const BASE_URL = OFFLINE_MODE
  ? process.env.VUE_APP_API_URL
  : "https://in.chatsee.me:38752";
export const UPLOAD_API_URL = OFFLINE_MODE
  ? process.env.VUE_APP_API_URL
  : "https://in.chatsee.me:42750";
export const API_URL = `${BASE_URL}/app/`;
export const CAMTALK_API_URL = 'https://api.camtalkaws.com:38753/app/'
// export const CAMTALK_API_URL = 'https://test.camtalkaws.com:38754/app/'
export const XMPP_SERVER = "https://in.chatsee.me:8080/http-bind/";
export const XMPP_SERVER_DOMAIN = "in.chatsee.me";
export const APP_MARKET_CODE = "web";
export const PAGE_SIZE = 50;
export const RESIGNUP_DELAY_DAYS = 3;
export const FCM_VAPID_KEY =
  "BD3-TtObaa_Qh2rgaw0YiuGlIt7VzYjf0JtD5DEAp128iPm1qzMlp5g0tx7p2PuktCtvcMxPyi0dWaYg8j8fJpw";
export const GOOGLE_CLIENT_ID =
  "277906408897-ql5d7h0de3k8bkksal8997fkql0036j2.apps.googleusercontent.com";

export const GIFT_ITEM_POINTS = [10, 30, 100, 300, 900];
export const GIFT_ITEM_IMAGES = [
  "gift_item1",
  "gift_item2",
  "gift_item3",
  "gift_item4",
  "gift_item5",
];
export const GIFT_ITEM_NAMES = ["손하트", "꽃다발", "링", "궁전", "메가하트"];
export const VIDEO_CHAT_GIFT_ITEM_POINTS = [10, 30, 100, 300, 900];

export const UPLOAD_MOMENT_IMAGE = 0;
export const UPLOAD_PROFILE_IMAGE = 1;
export const UPLOAD_ASK_IMAGE = 2;

export const EVENT_NAME = {
  PHOTO_DELETE: "photo_delete",
  PROFILE_BACK: "profile_back_press",
  MESSAGE_DETAIL_BACK: "message_detail_back_press",
  GIFTICON_BACK: "gifticon_back_press",
  HOME_BACK: "home_back_press",
  PURCHASE_SUCCESS: "purchase_success",
  PAYPAL_PURCHASE_SUCCESS: "paypal_purchase_success",
  VIDEO_REQUEST_CANCEL: "video_request_cancel",
  VIDEO_REQUEST_REFUSE: "video_request_refuse",
  NEW_MESSAGE_TEXT: "new_msg_text",
  NEW_MESSAGE_IMAGE: "new_msg_image",
  NEW_MESSAGE_VIDEO: "new_msg_video",
  NEW_MESSAGE_GIFT: "new_msg_gift",
  VIDEO_REVIEW: "video_review",
  REPORT: "report",
  REPORT_SUCCESS: "report_success",
  CHECK_DB: "check_db",
  CHARGE_PAGE_RESUME: "charge_page_resume",
  CLOSE_DIALOGS: "close_dialogs",
  EXTERNAL_NEW_VIDEO_REQUEST: "external_new_video_request",
  EXTERNAL_VIDEO_FINISHED: "external_video_finished",
};

export const MEDIA_TYPE = {
  CAMERA: "camera",
  GALLERY: "gallery",
  VIDEO: "video",
};

export const ROUTES = [
  "/live",
  "/recommend",
  "/moment",
  "/chat",
  "/profile",
  "/charge",
  "/history",
  "/guide",
  "/announce",
  "/ham",
];

export const CHARGE_ITEM = [
  {
    POINT: "3,900",
    PRICE_IN: 39000.0,
  },
  {
    POINT: "10,100",
    PRICE_IN: 99000.0,
  },
  {
    POINT: "17,000",
    PRICE_IN: 159000.0,
  },
  {
    POINT: "41,000",
    PRICE_IN: 359000.0,
  },
  {
    POINT: "124,300",
    PRICE_IN: 990000.0,
  },
];

export const VIP_ITEM = [
  {
    POINT: "35,000",
    PRICE: "50,000",
    PRICE_USD: 79.99,
  },
  {
    POINT: "70,000",
    PRICE: "100,000",
    PRICE_USD: 159.99,
  },
];

// export const PG_VIRTUAL_ACCOUNT_ITEMS = [
//   {
//     bankCode: "014",
//     productCode: "BCAATM",
//     productName: "BCA VA Online",
//   },
//   {
//     bankCode: "002",
//     productCode: "BRIATM",
//     productName: "BRI VA",
//   },
//   {
//     bankCode: "022",
//     productCode: "CIMBATM",
//     productName: "VA CIMB Niaga",
//   },
//   {
//     bankCode: "011",
//     productCode: "DANAMONATM",
//     productName: "DANAMON VA",
//   },
//   {
//     bankCode: "016",
//     productCode: "BIIATM",
//     productName: "BII VA",
//   },
//   {
//     bankCode: "013",
//     productCode: "PERMATAATM",
//     productName: "PERMATA VA",
//   },
//   {
//     bankCode: "013",
//     productCode: "PERMATAATM",
//     productName: "PERMATA VA",
//   },
//   {
//     bankCode: "016",
//     productCode: "BIIATM",
//     productName: "BII VA",
//   },
// ];

// export const PG_LINKAJA_ITEMS = [
//   {
//     bankCode: "008",
//     productCode: "LINKAJAQRPAY",
//     productName: "Link Aja QR Pay",
//   },
//   {
//     bankCode: "008",
//     productCode: "TCASH",
//     productName: "Link Aja T",
//   },
//   {
//     bankCode: "008",
//     productCode: "LINKAJAAPPLINK",
//     productName: "Link Aja Applink",
//   },
// ];

// export const PG_OTHER_ITEMS = [
//   {
//     bankCode: "008",
//     productCode: "CREDITCARD",
//     productName: "Credit Card Visa/Master/JCB",
//   },
//   {
//     bankCode: "008",
//     productCode: "SALDOMUQR",
//     productName: "SALDOMU QR",
//   },
//   {
//     bankCode: "503",
//     productCode: "OVO",
//     productName: "OVO",
//   },
// ];

export const PG_VIRTUAL_ACCOUNT_ITEMS = [
  {
    bankCode: "037",
    productCode: "ARTHAGRAHAATM",
    productName: "VA ARTHA GRAHA",
  },
  {
    bankCode: "490",
    productCode: "BNCATM",
    productName: "VA Bank Neo Commerce",
  },
  {
    bankCode: "009",
    productCode: "BNIATM",
    productName: "VA BNI",
  },
  {
    bankCode: "002",
    productCode: "BRIATM",
    productName: "VA BRI",
  },
  {
    bankCode: "200",
    productCode: "BTNATM",
    productName: "VA BTN",
  },
  {
    bankCode: "213",
    productCode: "BTPNATM",
    productName: "VA BTPN",
  },
  {
    bankCode: "022",
    productCode: "CIMBATM",
    productName: "VA CIMB Niaga",
  },
  {
    bankCode: "011",
    productCode: "DANAMONATM",
    productName: "VA DANAMON ",
  },
  {
    bankCode: "111",
    productCode: "BANKDKIATM",
    productName: "VA Bank DKI",
  },
  {
    bankCode: "008",
    productCode: "MANDIRIATM",
    productName: "VA MANDIRI ",
  },
  {
    bankCode: "157",
    productCode: "MASPIONATM",
    productName: "VA MASPION",
  },
  {
    bankCode: "013",
    productCode: "PERMATAATM",
    productName: "VA PERMATA",
  },
  {
    bankCode: "153",
    productCode: "BANKSINARMASATM",
    productName: "VA Bank Sinarmas",
  },
  {
    bankCode: "016",
    productCode: "BIIATM",
    productName: "VA Maybank ",
  },
  {
    bankCode: "490",    
    productCode: "BNCATM",
    productName: "VA Bank Neo Commerce",
  }
];

export const PG_EWALLET_ITEMS = [
  {
    "bankCode": "701",
    "productCode": "TOKPEDESPAYGOPAY",
    "productName": "Tokopedia ESPAY GOPAY"
  },
  {
    "bankCode": "503",
    "productCode": "OVO",
    "productName": "OVO"
  },
];

export const PG_BOOTH_ITEMS = [
  {
    bankCode: "800",
    productCode: "INDOMARETESPAY",
    productName: "INDOMARET ESPAY",
  },
  {
    bankCode: "801",
    productCode: "ALFAMARTESPAY",
    productName: "ALFAMART ESPAY",
  },
];

export const PG_OTHER_ITEMS = [
  {
    bankCode: "002",
    productCode: "EPAYBRI",
    productName: "e-Pay BRI",
  },
  {
    bankCode: "008",
    productCode: "SALDOMUQR",
    productName: "SALDOMU QRIS",
  },
  {
    bankCode: "013",
    productCode: "PERMATANETPAY",
    productName: "PermataNet",
  },
];
